import { Routes } from '@angular/router';
import { AuthGuard } from './Guards/auth-guard.guard';
import { TwixorChat } from './Guards/twixor-chat.guard';
import {
  ChatColorsResolver,
  ChatUrlResolver,
  CountryCodeResolver,
  CustomerDetailsResolver,
  CustomerIdResolver,
  DepartmentIdResolver,
  EIdResolver,
} from './twixor-chat.resolver';
import { ChatComponent } from './Components/GeneralComponents/chat/chat.component';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home-page/home.page').then((m) => m.HomePage),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'patients',
    loadComponent: () =>
      import('./pages/patients-page/patients.page').then((m) => m.PatientsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    loadComponent: () =>
      import(
        './Components/GeneralComponents/profile-view/profile-view.component'
      ).then((m) => m.ProfileViewComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'orders',
    loadComponent: () =>
      import('./pages/orders-page/orders.page').then((m) => m.OrdersPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'documents',
    loadComponent: () =>
      import('./pages/documents-page/documents.page').then(
        (m) => m.DocumentsPagePage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'action-items',
    loadComponent: () =>
      import('./pages/action-items-page/action-items.page').then(
        (m) => m.ActionItemsPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'services',
    loadComponent: () =>
      import('./pages/services-page/services.page').then((m) => m.ServicesPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'services/requests',
    loadComponent: () =>
      import('./pages/service-requests-page/service-requests.page').then(
        (m) => m.ServiceRequestsPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'services/requests/:id/submitted',
    loadComponent: () =>
      import(
        './pages/service-request-submitted-page/service-request-submitted.page'
      ).then((m) => m.ServiceRequestSubmittedPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'services/requests/:id',
    loadComponent: () =>
      import(
        './pages/service-request-details-page/service-request-details.page'
      ).then((m) => m.ServiceRequestDetailsPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'services/:serviceId/request',
    loadComponent: () =>
      import(
        './pages/service-request-form-page/service-request-form.page'
      ).then((m) => m.ServiceRequestFormPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'role-switcher',
    loadComponent: () =>
      import('./pages/role-switcher/role-switcher.page').then(
        (m) => m.RoleSwitcherPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'submissions',
    loadComponent: () =>
      import('./pages/submissions/submissions.page').then(
        (m) => m.SubmissionsPage
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'billing',
    loadComponent: () =>
      import('./pages/billing/billing.page').then((m) => m.BillingPage),
    canActivate: [AuthGuard],
  },
  {
    path: 'CycleCardDetails',
    loadComponent: () =>
      import(
        './Components/GeneralComponents/cycle-card-details/cycle-card-details.component'
      ).then((m) => m.CycleCardDetailsComponent),
    canActivate: [AuthGuard],
  },

  {
    path: 'chat',
    component: ChatComponent,
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('chat-library').then((m) => m.ChatPageModule),
      },
    ],
    resolve: {
      url: ChatUrlResolver,
      departmentId: DepartmentIdResolver,
      customerId: CustomerIdResolver,
      eId: EIdResolver,
      countryCode: CountryCodeResolver,
      customerDetails: CustomerDetailsResolver,
      chatColors: ChatColorsResolver,
    },

    canActivate: [AuthGuard, TwixorChat],
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./pages/register/register.page').then((m) => m.RegisterPage),
  },
];
